import { z } from 'zod';
import { CaseIdSchema, EventIdSchema, IsoTimestampSchema, UserIdSchema } from './common.js';
import { EventTypeSchema } from './event.js';

/**
 * Stjernemerking av viktige hendelser i en sak (delt mellom saksmedlemmer).
 * Felt som `timestamp`, `title` og `type` er denormalisert fra Event slik at
 * tidslinjevisningen kan lastes i én query uten oppslag per hendelse.
 */
export const HighlightSchema = z.object({
  eventId: EventIdSchema,
  caseId: CaseIdSchema,
  timestamp: IsoTimestampSchema,
  title: z.string().min(1).max(500),
  type: EventTypeSchema,
  note: z.string().max(2000).optional(),
  createdBy: UserIdSchema,
  createdAt: IsoTimestampSchema,
});

export type Highlight = z.infer<typeof HighlightSchema>;
